export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_ERROR = "USER_ERROR";
export const USER_SET_LEVEL = "USER_SET_LEVEL";
export const USER_SET_PERMISSIONS = "USER_SET_PERMISSIONS";
export const USER_SET_PERMESSI_ATTUALI = "USER_SET_PERMESSI_ATTUALI";
export const USER_RESET = "USER_RESET";
